import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../LoadingSpinner';
import { Icon } from '@iconify/react';

const ContactForm = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate data fetching
    setTimeout(() => {
      setIsLoading(false); // Stop spinner after fetching data
    }, 1000);
  }, []);

  const applyBtnStyle = {
    backgroundColor: '#007bff',
    color: '#fff',
    padding: '2px 4px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    textAlign: 'left'
  };


  
  const NaviconStyle = {
    marginRight: '10px', // Margin between icon and text
    marginTop: '10px',
    marginLeft: '10px',
  };

/*
  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div >
      
       {isLoading ? (
  <LoadingSpinner />
) : (
  <div>
    <button onClick={handleRefresh} >
  <Icon icon="fa:refresh" color="black" width="17" height="17" style={NaviconStyle}/> 
    </button>
     <div style={{ marginTop: "10px", marginRight:"10px",  display: "flex", justifyContent: "flex-end" }} >
      
      <a href={'https://eepurl.com/i8ANKU'} target="_self" rel="noopener noreferrer">

<button
style={applyBtnStyle}
>
Sign up to receive email updates
</button>
</a>
</div>
     </div>

     
       )}
      <div>
      <div style={{ marginTop: "10px", marginLeft:"10px", marginRight:"10px",  display: "flex",  fontStyle: "italic", color: "grey" }}>This programme is still in the early stages, please give it time.</div>

      </div>
     
    </div>
  );

*/

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div>
      
      {isLoading ? (
  <LoadingSpinner />
) : (
      <iframe
        src="https://www.spcommunity.org.za/job-posts/"
        style={{ width: "100%", height: "100vh", border: "none", overflow: "auto" }}
        title="Contact Form"
        onLoad={() => setIsLoading(false)} // Hide spinner when iframe loads
      ></iframe>
    )}
    </div>
  ); 
};

export default ContactForm;
